import React from 'react';
import Ionicon from 'react-ionicons';

 const ProjectItem = props => {

    return (
      <div className="col-md-4 text-center project-item">
        <a href={props.url} target="_blank" rel="noopener noreferrer">
          <img
            alt=""
            className="img-rounded img-responsive"
            src={props.img_url}
          />
        </a>
        <a
          href={props.repo}
          target="_blank"
          rel="noopener noreferrer">
          <Ionicon icon="ion-social-github" fontSize="50px" color='red' />
        </a>
        <p className="project-item-description">
          <span className="white-underline">
            <a href={props.url} target="_blank" rel="noopener noreferrer">
              {props.title}
            </a>
          </span>{' '}
          {props.description}
        </p>
      </div>
    );
  };

export default ProjectItem;



// WEBPACK FOOTER //
// ./src/components/project_item.js